import { Spin } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearListCompactAction,
  listAgenciesCompactAction,
} from "../../store/agency/agencyActions";
import { clearRenewalList } from "../../store/renewal/renewalActions";
import PermissionWrapper from "../navigation/PermissionWrapper";
import { UpdateRenewalData } from "../shared/securityRoleTasks";
import RenewalsForm from "./RenewalsForm";
import { Route, Routes } from "react-router-dom";
import RenewalForm from "./RenewalForm";
import { PreservableStatePageWrapper } from "../shared/PreservableStatePageWrapper";
import { tableNames } from "../shared/table/tableNames";

const Renewals = () => {
  //
  const dispatch = useDispatch();

  //
  const brokerId = useSelector((state) => state.actor.details.data.BrokerId);
  const agencies = useSelector((state) => state.agency.listCompact);
  const agenciesLoading = useSelector((state) => state.agency.loading);
  //
  const pageLoaded = brokerId != null && agencies != null && !agenciesLoading;

  //
  useEffect(() => {
    if (brokerId != null) {
      dispatch(listAgenciesCompactAction(brokerId, UpdateRenewalData));
    }
  }, [brokerId, dispatch]);

  useEffect(() => {
    dispatch(clearListCompactAction());
    dispatch(clearRenewalList());
  }, []);

  return (
    <PreservableStatePageWrapper
      onCleanup={() => {}}
      tableNames={[tableNames.Renewals]}
    >
      <PermissionWrapper entityName="Renewals2">
        <Routes>
          <Route
            path=""
            element={
              <Spin spinning={!pageLoaded} delay={500}>
                {pageLoaded && <RenewalsForm agencies={agencies} />}
              </Spin>
            }
          />
          <Route path="renewalform/:renewalKey" element={<RenewalForm />} />
        </Routes>
      </PermissionWrapper>
    </PreservableStatePageWrapper>
  );
};

export default Renewals;
